import { tProvidersProps } from '../Layout.types';

export default function PublicLayout(props: tProvidersProps) {
  const { children } = props;

  return children;
}
